<template>
  <div class="animated fadeIn">
    <basic-heading title="Orders" />
    <b-row class="px-0 m-0 bg-light my-3">
      <b-col v-for="(indicator, index) in indicators" :key="index" class="pl-0">
        <indicator-tile
          :text="indicator.text"
          :indicator_key="indicator.indicator_key"
          :indicator_service="indicator.indicator_service"
          :faIcon="indicator.faIcon"
          :variant="indicator.variant"
        />
      </b-col>
      <b-col class="px-0">
        <indicator-tile
          text="Un-Paid Total"
          indicator_key="unpaid-invoice-total"
          indicator_service="cashier"
          faIcon="hand-holding-usd"
          variant="warning"
        >
          <template #default="slotProps">
            {{
              slotProps.value
                ? `$${Math.abs(slotProps.value).toFixed(2)}`
                : "N/A"
            }}
          </template>
        </indicator-tile>
      </b-col>
    </b-row>
    <invoice-server-table />
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import InvoiceServerTable from "@/components/cashier/invoice/InvoiceServerTable";
import IndicatorTile from "@/components/shared/IndicatorTile";
import { order_indicators } from "@/shared/_indicators";

export default {
  name: "OrderIndex",
  components: {
    IndicatorTile,
    InvoiceServerTable,
    BasicHeading,
  },
  data() {
    return {
      indicators: order_indicators,
    };
  },
  methods: {},
  mounted() {},
};
</script>
